/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { createScheduledEmail } from '../fn/emails/create-scheduled-email';
import { CreateScheduledEmail$Params } from '../fn/emails/create-scheduled-email';
import { deleteScheduledEmail } from '../fn/emails/delete-scheduled-email';
import { DeleteScheduledEmail$Params } from '../fn/emails/delete-scheduled-email';
import { getScheduledEmail } from '../fn/emails/get-scheduled-email';
import { GetScheduledEmail$Params } from '../fn/emails/get-scheduled-email';
import { getScheduledEmails } from '../fn/emails/get-scheduled-emails';
import { GetScheduledEmails$Params } from '../fn/emails/get-scheduled-emails';
import { ScheduledEmail } from '../models/scheduled-email';
import { updateScheduledEmail } from '../fn/emails/update-scheduled-email';
import { UpdateScheduledEmail$Params } from '../fn/emails/update-scheduled-email';

@Injectable({ providedIn: 'root' })
export class EmailsService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getScheduledEmails()` */
  static readonly GetScheduledEmailsPath = '/emails';

  /**
   * Gets all scheduled emails [policies: GlobalAdmin].
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getScheduledEmails()` instead.
   *
   * This method doesn't expect any request body.
   */
  getScheduledEmails$Response(params?: GetScheduledEmails$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ScheduledEmail>>> {
    const obs = getScheduledEmails(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Gets all scheduled emails [policies: GlobalAdmin].
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getScheduledEmails$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getScheduledEmails(params?: GetScheduledEmails$Params, context?: HttpContext): Observable<Array<ScheduledEmail>> {
    const resp = this.getScheduledEmails$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<ScheduledEmail>>): Array<ScheduledEmail> => r.body)
    );
  }

  /** Path part for operation `createScheduledEmail()` */
  static readonly CreateScheduledEmailPath = '/emails';

  /**
   * Creates a new scheduled email [policies: GlobalAdmin].
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createScheduledEmail()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  createScheduledEmail$Response(params?: CreateScheduledEmail$Params, context?: HttpContext): Observable<StrictHttpResponse<ScheduledEmail>> {
    const obs = createScheduledEmail(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Creates a new scheduled email [policies: GlobalAdmin].
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createScheduledEmail$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  createScheduledEmail(params?: CreateScheduledEmail$Params, context?: HttpContext): Observable<ScheduledEmail> {
    const resp = this.createScheduledEmail$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<ScheduledEmail>): ScheduledEmail => r.body)
    );
  }

  /** Path part for operation `getScheduledEmail()` */
  static readonly GetScheduledEmailPath = '/emails/{id}';

  /**
   * Gets a specific scheduled email [policies: GlobalAdmin].
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getScheduledEmail()` instead.
   *
   * This method doesn't expect any request body.
   */
  getScheduledEmail$Response(params: GetScheduledEmail$Params, context?: HttpContext): Observable<StrictHttpResponse<ScheduledEmail>> {
    const obs = getScheduledEmail(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Gets a specific scheduled email [policies: GlobalAdmin].
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getScheduledEmail$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getScheduledEmail(params: GetScheduledEmail$Params, context?: HttpContext): Observable<ScheduledEmail> {
    const resp = this.getScheduledEmail$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<ScheduledEmail>): ScheduledEmail => r.body)
    );
  }

  /** Path part for operation `updateScheduledEmail()` */
  static readonly UpdateScheduledEmailPath = '/emails/{id}';

  /**
   * Updates a scheduled email [policies: GlobalAdmin].
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateScheduledEmail()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  updateScheduledEmail$Response(params: UpdateScheduledEmail$Params, context?: HttpContext): Observable<StrictHttpResponse<ScheduledEmail>> {
    const obs = updateScheduledEmail(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Updates a scheduled email [policies: GlobalAdmin].
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateScheduledEmail$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  updateScheduledEmail(params: UpdateScheduledEmail$Params, context?: HttpContext): Observable<ScheduledEmail> {
    const resp = this.updateScheduledEmail$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<ScheduledEmail>): ScheduledEmail => r.body)
    );
  }

  /** Path part for operation `deleteScheduledEmail()` */
  static readonly DeleteScheduledEmailPath = '/emails/{id}';

  /**
   * Deletes a scheduled email [policies: GlobalAdmin].
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteScheduledEmail()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteScheduledEmail$Response(params: DeleteScheduledEmail$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = deleteScheduledEmail(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Deletes a scheduled email [policies: GlobalAdmin].
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteScheduledEmail$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteScheduledEmail(params: DeleteScheduledEmail$Params, context?: HttpContext): Observable<void> {
    const resp = this.deleteScheduledEmail$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
